'use client';
import { createBrowserClient } from '@supabase/ssr';

/**
 * Browser Supabase client — used by the WEB app for social auth only
 * (Google / Facebook), per the MEDLUX proposal. The NestJS backend talks to
 * Postgres directly via Prisma and does NOT use supabase-js.
 *
 * NOTE (MVP): this client is provided but NOT wired into any screen yet — the
 * first delivery is visuals-only. Set NEXT_PUBLIC_SUPABASE_* in .env.local
 * before connecting auth.
 */
export function createClient() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    // Keep the visual build resilient when env is not configured.
    console.warn(
      '[supabase] NEXT_PUBLIC_SUPABASE_URL / NEXT_PUBLIC_SUPABASE_ANON_KEY are not set. ' +
        'Auth is disabled until configured.',
    );
  }

  return createBrowserClient(url ?? 'http://localhost', anonKey ?? 'anon');
}
